import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { Field } from 'redux-form'

import {
  Modal,
  Button
} from 'react-bootstrap'

import {
  renderSelectField
} from '../../Forms/fieldRenderers'

class PuestoCaladoPicker extends Component {
  constructor (props) {
    super(props)
    this.renderPuestosCalado = this.renderPuestosCalado.bind(this)
    this.onSelect = this.onSelect.bind(this)
  };

  componentDidMount () {
    this.props.requestPuestosCalado(this.props.place)
  };

  onSelect (puestoCalado) {
    const options = puestoCalado.target.options
    const label = options[options.selectedIndex].label
    if (puestoCalado) {
      this.props.setPuestoCalado(
        puestoCalado.target.value,
        label
      )
    }
  }

  renderPuestosCalado () {
    const {
      puestosCalado
    } = this.props

    const options = puestosCalado.map((puestoCalado, index) => {
      return (
        <option
          value={puestoCalado.puesto}
          key={index + 1}
        >
          {puestoCalado.nombrePuesto}
        </option>
      )
    })
    options.unshift((<option value={null} key={0} />))
    return options
  };

  render () {
    const {
      onSubmit,
      show,
      isRequesting,
      selectedPuestoCalado,
      selectedNombrePuestoCalado,
      selectedCalleA,
      selectedCalleB
    } = this.props
    return (
      <Modal show={show}>
        <form >
          <Modal.Header>
            <span>Seleccione puesto de calado</span>
          </Modal.Header>
          <Modal.Body>
            <Field
              onChange={this.onSelect}
              name='puestoCalado'
              label='Puesto de calado'
              autoFocus={false}
              component={renderSelectField}
              value={selectedPuestoCalado}>
              {isRequesting ? null : this.renderPuestosCalado()}
            </Field>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type='submit'
              variant='primary'
              onClick={() => onSubmit(
                selectedPuestoCalado, selectedNombrePuestoCalado,
                selectedCalleA, selectedCalleB)}
            >Seleccionar</Button>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return {
    isRequesting: state.puestoCalado.requesting,
    puestosCalado: state.puestoCalado.puestosCalado,
    selectedPuestoCalado: state.puestoCalado.puestoCalado,
    selectedNombrePuestoCalado: state.puestoCalado.nombrePuestoCalado,
    selectedCalleA: state.puestoCalado.calleA,
    selectedCalleB: state.puestoCalado.calleB
  }
};

const withRedux = connect(mapStateToProps, actions)

export default withRedux(PuestoCaladoPicker)
